import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import React, { useRef, useState } from 'react';
import { fetchdata } from './../reduxactions/fundmanagersactions/OrgApplicationsActions';
import { useNavigate } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';

const Orgapplications = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.fmapp.data);


  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  const navigate = useNavigate();
  //To open view
  const orgappprove = (rowData: any) => {
    const url = `/orgaproveapp/${rowData.application_id}`;
    console.log('Row ID:', rowData.userid
    );
    // Use navigate to navigate to the URL
    navigate(url);
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/fmorganizationapplication.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Organisation Applications</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              <div className="grid">
                <div className="col-12">
                  <div className="card card-primary">
                    <div className="card flex flex-wrap justify-content-end my-2">
                      <span className="p-input-icon-left">
                        <i className="pi pi-search ml-2" />

                        <InputText
                          className="app-search-input"
                          value={globalFilter}
                          onChange={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Global Search"
                        />
                      </span>
                    </div>
                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                      <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                      <Column field="email" sortable header="Email "></Column>
                      <Column field="CountryName" sortable header="Country Name"></Column>
                      <Column field="applied_date" sortable header="Applied Date"></Column>
                      <Column field="expired_date" sortable header="Expired Date"></Column>
                      <Column field="status" sortable header="Status"></Column>
                      <Column header="Operation" body={(rowData) => (
                        <>
                          {/* <Button icon="pi pi-eye" tooltip="View" rounded outlined className='mr-1' aria-label="View" onClick={() => orgappprove(rowData)} style={{ color: 'blue' }} /> */}
                          <GFNButton icon="pi pi-eye" tooltip="View" rounded outlined className='mr-1' aria-label="View" onClick={() => orgappprove(rowData)} buttonType='primary' />
                        </>
                      )} />
                    </DataTable>
                  </div>
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    </div>
  )

}
export default Orgapplications


